import { create } from "zustand";
import { RuleModel } from "../shared/models/rule";

export const rulesStore = create<{ rules: RuleModel[] }>(() => ({
    rules: [],
}));

export const setRules = (rules: RuleModel[]) => {
    rulesStore.setState({ rules });
};
